import { WebSocketService } from '../../web-socket.service';
import { WebSocketClientService } from '../../web-socket-cliente.service';
import Swal from 'sweetalert2';

import { Component, OnInit, HostListener } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilaAtendimentoModalComponent } from './fila-atendimento-modal/fila-atendimento-modal.component';
import { 
  faWifi, 
  faUserGroup, 
  faUserGear, 
  faRightFromBracket,
  faCircle,
  faPowerOff
} from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [
    trigger('slideToggle', [
      state('closed', style({
        height: '0',
        opacity: 0,
        overflow: 'hidden'
      })),
      state('open', style({
        height: '*',
        opacity: 1
      })),
      transition('closed <=> open', animate('300ms ease-in-out'))
    ]),
    trigger('slideInOut', [
        state('void', style({
            opacity: 0,
            transform: 'translateX(-100%)'
        })),
        state('*', style({
            opacity: 1,
            transform: 'translateX(0)'
        })),
        transition('void <=> *', animate('300ms ease-in-out'))
    ])
  ]
})
export class HeaderComponent {

  public isOnline: boolean = false;
  public nomeOperador: string| null = '';
  public rolesUsuario: string| null = ''
  public empresa: string| null = '';
  menuState: string = 'closed';
  public headerForm: FormGroup;
  currentLanguage: string = 'en';
  dropdownOpen: boolean = false;
    // Lista de idiomas disponíveis
    languages = [
      {
        code: 'pt',
        name: 'Português',
        flag: 'https://flagcdn.com/w320/br.png'
      },
      {
        code: 'en',
        name: 'English',
        flag: 'https://flagcdn.com/w320/us.png'
      }
    ];

  atendimentos: any[] = [];
  usersLoaded: boolean = false;
  isLoadingFilaAtendimento: boolean = false;

  // Ícones
  faWifi = faWifi;
  faPowerOff = faPowerOff;
  faUserGroup = faUserGroup;
  faUserGear = faUserGear;
  faRightFromBracket = faRightFromBracket;
  faCircle = faCircle;

  constructor(private translate: TranslateService, private fb: FormBuilder, private webSocketService: WebSocketService, private WebSocketClientService: WebSocketClientService,  private toastr: ToastrService, public router: Router, private http: HttpClient, private modalService: NgbModal) {
    this.nomeOperador =  localStorage.getItem('nomeUsuario');
    this.rolesUsuario=  localStorage.getItem('rolesUsuario');
    
    this.empresa =  localStorage.getItem('empresa');
    this.headerForm = this.fb.group({
      searchControl:  [""]
    });
     // Define o idioma atual baseado no TranslateService ou localStorage
     const savedLanguage  = localStorage.getItem('language') || 'pt';
     this.currentLanguage = savedLanguage;
     this.translate.use(this.currentLanguage);
  }

 
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectLanguage(lang: string) {
    this.currentLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.dropdownOpen = false; // Fecha o dropdown
  }

  getFlag(lang: string): string {
    return this.languages.find(language => language.code === lang)?.flag || '';
  }

  getLanguageName(lang: string): string {
    return this.languages.find(language => language.code === lang)?.name || '';
  }

  toggleMenu() {
    this.menuState = this.menuState === 'open' ? 'closed' : 'open';
  }

  profile() {
    alert('Perfil ainda em desenvolvimento');
  }

  logOut() {
    localStorage.clear();
    this.router.navigateByUrl("/auth/login");
    this.webSocketService.disconnect();
    this.WebSocketClientService.disconnect();
  }

  stayOffline()
  {
    Swal.fire({
      text : 'Ficando offline você não receberá mensagens internas e dos seus cliente. Deseja continuar ?',
      showCancelButton : true,
      confirmButtonText : 'SIM',
      cancelButtonText : 'Não',
      customClass : {
        confirmButton : 'btn btn-primary icon',
        cancelButton : 'btn btn-secondary icon',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.webSocketService.disconnect();
        this.WebSocketClientService.disconnect();
        this.isOnline = false;
        this.toastr.success('Você está offline.');
        this.toggleMenu();

      }
    })

  }
  
  verFilaAtendimento() {
    this.isLoadingFilaAtendimento = true;

    this.http.get<any>(`${environment.apiUrl}/ticket/chat/queue`).subscribe(
      (response) => {
        this.atendimentos = response;
        this.usersLoaded = true;
        this.isLoadingFilaAtendimento = false;
        
        // Abre o modal com a fila de atendimento
        const modalRef = this.modalService.open(FilaAtendimentoModalComponent, { 
          size: 'lg',
          centered: true
        });
        modalRef.componentInstance.atendimentos = this.atendimentos;
      },
      (error) => {
        console.error('Error:', error);
        this.isLoadingFilaAtendimento = false;
      }
    );
  }

  private destroy$ = new Subject<void>();
  username: string = '';
  connectedUsers: any[] = [];

  stayOnline(){

    Swal.fire({
      text : 'Ficando online você receberá mensagens internas e dos seus cliente. Deseja continuar ?',
      showCancelButton : true,
      confirmButtonText : 'SIM',
      cancelButtonText : 'Não',
      customClass : {
        confirmButton : 'btn btn-primary icon',
        cancelButton : 'btn btn-secondary icon',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.confirmedOnline();
        this.toastr.success('Você está online.');
        this.toggleMenu();
      }
    })
  }

  confirmedOnline(){

        this.webSocketService.connect();
        this.isOnline = true;
        this.webSocketService.getMessages().pipe(takeUntil(this.destroy$)).subscribe(jsonObject => {

          var usuariologado = localStorage.getItem('username');
          var uuidlogado = localStorage.getItem('username');
            console.log('header json',jsonObject);
    
            if (jsonObject.action === 'getconnectedusers') {
              this.connectedUsers = this.connectedUsers.filter((user: any) => user.username !== usuariologado);
              //console.log("this.connectedUsers: '" + this.connectedUsers + "'");
            }
            else if(jsonObject.action === 'onmessage'){
    
                console.log('-ngOnInit no heder 2-');
                console.log(jsonObject);
                // this.toastr.success(jsonObject.data.userData.sender +": "  + jsonObject.data.message);
                
                //const message = `<span class="fas fa-comments"></span> ${jsonObject.data.userData.sender +": "  + jsonObject.data.message}`;
                
                const message = `
                <span class="fas fa-comments"></span> 
                <a href="#" id="toaster-link-${jsonObject.data.ticketId}" style="color: white; text-decoration: underline;">
                   * ${jsonObject.data.userData.sender +": "  + jsonObject.data.message}
                </a>
              `;
                
                this.toastr.show(message, '-Nova mensagem-',{
                  enableHtml: true,
                  toastClass: 'ngx-toastr toast-custom'
                });
                let audio = new Audio();
                audio.src = "assets/audio/message-incoming.mp3";
                audio.load();
                audio.play().catch(function(error) {
                  console.log('Audio playback failed: ', error);
                });
                this.showNotification("Nova mensagem", message);

                  // Adicionar um evento de clique no link após um pequeno delay para garantir que o toaster foi renderizado
                  setTimeout(() => {
                    const toastLink = document.getElementById(`toaster-link-${jsonObject.data.ticketId}`);
                    if (toastLink) {
                      toastLink.addEventListener('click', (event) => {
                        alert('clicou');
                        event.preventDefault(); // Impede o comportamento padrão do link
                        this.router.navigateByUrl(`/tickets/${jsonObject.data.ticketId}/edit`);
                      });
                    }
                  }, 100);
    
            }
            else if(jsonObject.action === 'alert'){
    
              console.log('alert', jsonObject);
              // this.toastr.success(jsonObject.data.userData.sender +": "  + jsonObject.data.message);
              
              //const message = `<span class="fas fa-comments"></span> 1 ${jsonObject.data.message }`;
              const message = `
              <span class="fas fa-comments"></span> 
              <a href="#" id="toaster-link" style="color: white; text-decoration: underline;">
                 ${jsonObject.data.message}
              </a>
            `;
              
              this.toastr.show(message, jsonObject.data.title,{
                enableHtml: true,
                toastClass: 'ngx-toastr toast-custom'
              });
              let audio = new Audio();
              audio.src = "assets/audio/message-incoming.mp3";
              audio.load();
              audio.play().catch(function(error) {
                console.log('Audio playback failed: ', error);
              });
              this.showNotification(jsonObject.data.title, jsonObject.data.message);

              // Adicionar um evento de clique no link após um pequeno delay para garantir que o toaster foi renderizado
              setTimeout(() => {
                const toastLink = document.getElementById(`toaster-link`);
                if (toastLink) {
                  alert('clicou 2');
                  toastLink.addEventListener('click', (event) => {
                    event.preventDefault(); // Impede o comportamento padrão do link
                    this.router.navigateByUrl(`/tickets/chat`);
                  });
                }
              }, 100);

            }
            else if(jsonObject.action === 'newchatusernotification'){
    
              //console.log('chegou newchatusernotification');
              console.log(jsonObject);
              // this.toastr.success(jsonObject.data.userData.sender +": "  + jsonObject.data.message);
              
              //const message = `<span class="fas fa-comments"></span> ${jsonObject.data.message }`;

                const message = `
                  <span class="fas fa-comments"></span> 
                  <a href="#" id="toaster-link-${jsonObject.data.ticketId}" style="color: white; text-decoration: underline;">
                    ! ${jsonObject.data.message}
                  </a>
                `;


              this.toastr.info(message, jsonObject.data.title,{
                enableHtml: true,
                toastClass: 'ngx-toastr toast-custom'
              });
              let audio = new Audio();
              audio.src = "assets/audio/message-incoming.mp3";
              audio.load();
              audio.play().catch(function(error) {
                console.log('Audio playback failed: ', error);
              });


              var ulrRedirect = "/tickets/"+jsonObject.data.ticketId+"/edit";
              if(jsonObject.data.type == "whatsapp")
                ulrRedirect =  "/whatsapp/chat?tahc="+jsonObject.data.phone;


              this.router.navigateByUrl(ulrRedirect)
              this.showNotification(jsonObject.data.title, jsonObject.data.message);

                // Adicionar um evento de clique no link após um pequeno delay para garantir que o toaster foi renderizado
                setTimeout(() => {
                  const toastLink = document.getElementById(`toaster-link-${jsonObject.data.ticketId}`);
                  if (toastLink) {
                    alert('clicou 2');
                    toastLink.addEventListener('click', (event) => {
                      event.preventDefault(); // Impede o comportamento padrão do link
                      this.router.navigateByUrl(ulrRedirect);
                    });
                  }
                }, 100);
            }
            if(jsonObject.action === 'disconnect'){
              
              alert("Você está conectado em outro dispositivo. Sua sessão será encerrada.");
              localStorage.clear();
              this.router.navigateByUrl("/auth/login");
              this.webSocketService.disconnect();
    
            }
        });
  }
  


  showNotification(title: string, body: string) {
    if (Notification.permission === 'granted') {
      console.log('chegou')
      new Notification(title, {
        body: body,
        icon: 'assets/images/notification-icon.png' // Ícone opcional
      });
    }
  }

  ngOnInit(): void {
    this.confirmedOnline();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  searchResults: any[] = [];
  showResults = false; 
  searchClick()
  {
    const searchControlText = this.headerForm.get('searchControl')?.value;
    if (!searchControlText) {
      console.error('htmlContent control not found');
      return;
    }
    console.log(searchControlText);

    this.http.get<any>(`${environment.apiUrl}/ticket/search/${searchControlText}`, ).subscribe(
      (response) => {
        console.error('Resultado:', response);
        if(response.length == 0)
          alert('Nenhum resultado encontrado.')
        this.searchResults = response;
        this.showResults = true;
      },
      (error) => {
        console.error('Error:', error);
      });
  }

  // Fechar a lista se o usuário clicar fora dela
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;
    const clickedInside = targetElement.closest('.search-results');
    
    console.log('clickedInside', clickedInside == null)
    if (!clickedInside || clickedInside == null) {
      this.showResults = false; // Esconder a lista ao clicar fora
    }
  }

  isSearchControlNotEmpty(): boolean {
    const searchControl = this.headerForm.get('searchControl');
    return searchControl && searchControl.value && searchControl.value.trim() !== '';
}

}
